import { writable } from "svelte/store";

//types
import type { AutoPaySettings } from "@shared/types/AutoPaySettings";

export type AutoPaySettingsRequest = {
  autoPaySettings: AutoPaySettings;
  loaded: boolean;
  failed: boolean;
};

export const initialAutoPaySettingsState: AutoPaySettingsRequest = {
  loaded: false,
  failed: false,
  autoPaySettings: {
    id: null,
    distributors: [],
    payment_instrument_id: null,
    use_credits: false,
  },
};

export const autoPaySettingsStore = writable<AutoPaySettingsRequest>(initialAutoPaySettingsState);
